import { useEffect } from 'react';
import './WhatsAppSubscription.css';
import { initializeTracker } from '../tracker_script.js';
import SEO from './SEO';

function WhatsAppSubscription() {
  // Replace this URL with your actual Stripe payment link
  const stripePaymentUrl = 'https://buy.stripe.com/8x2eVd2lq5pSfL1fov6Ri0l';

  useEffect(() => {
    // Add meta tags to head
    const usernameMeta = document.createElement('meta');
    usernameMeta.name = 'username';
    usernameMeta.content = 'user_2o6eptKfyuvEOe6kSTFVnGzxmMU';
    document.head.appendChild(usernameMeta);

    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'WhatsApp Access';
    document.head.appendChild(offerMeta);

    // Initialize the tracker
    try {
      initializeTracker();
      console.log('Tracker initialized successfully');
    } catch (error) {
      console.error('Error initializing tracker:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="username"]')) {
        document.querySelector('meta[name="username"]').remove();
      }
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="whatsapp-subscription-container">
      <SEO
        title="WhatsApp Subscription with Tuomas Kivioja | Internet Made Media FZCO"
        description="Get unlimited WhatsApp access to Tuomas Kivioja. Expert guidance on expat relocation, UAE company setup, Dubai visa, Mexico residency, and international business setup. $250/month, cancel anytime."
        keywords="Tuomas Kivioja WhatsApp, expat relocation support, UAE setup help, Dubai visa assistance, international relocation consultant, ongoing expat support, WhatsApp consultation"
        canonical="https://tuomaskivioja.com/whatsapp-subscription"
        ogImage="https://tuomaskivioja.com/tuomas.jpg"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "WhatsApp Subscription",
          "provider": {
            "@type": "Person",
            "name": "Tuomas Kivioja",
            "jobTitle": "International Relocation Specialist"
          },
          "description": "Unlimited WhatsApp access for ongoing expat relocation support",
          "offers": {
            "@type": "Offer",
            "price": "595",
            "priceCurrency": "USD",
            "description": "Monthly subscription, cancel anytime"
          },
          "url": "https://tuomaskivioja.com/whatsapp-subscription"
        }}
      />
      <h2>WhatsApp Access with Tuomas</h2>

      <div className="whatsapp-content-section">
        <h3>Get unlimited access to Tuomas on WhatsApp to ask anything you want.</h3>
        
        <p>Perfect for ongoing support as you navigate your international relocation, visa processes, residency options, or business setup questions.</p>
        
        <p className="pricing-text">
          The subscription is <strong><u>$595 per month</u></strong>. Cancel anytime with no long-term commitment.
        </p>

        <div className="features-list">
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Unlimited WhatsApp messages</span>
          </div>
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Response within 24 hours (usually faster)</span>
          </div>
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Expert guidance on relocation, visas, business setup, and expat life</span>
          </div>
          <div className="feature-item">
            <span className="check-icon">✓</span>
            <span>Cancel anytime, no long-term commitment required</span>
          </div>
        </div>

        <p className="meeting-note">
          <span className="note-icon">✕</span> <b>Note:</b> No in-person/video meetings are guaranteed. To book a meeting with Tuomas, <a style={{color: 'white'}} href="/consultation">please book a paid consultation.</a>
        </p>

        <a 
          href={stripePaymentUrl} 
          className="subscribe-btn"
          target="_blank" 
          rel="noopener noreferrer"
        >
          Subscribe Now
        </a>

        <p className="secure-note">🔒 Secure payment powered by Stripe</p>

        <p className="disclaimer-text">
          <i><b>Note: Tuomas is not a tax or investment advisor and cannot provide official tax or investment advice.</b></i>
        </p>
      </div>
    </div>
  );
}

export default WhatsAppSubscription;
